import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HTTPService, HelperService, FormatService } from 'app/services';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

@Component({
  selector: 'app-update-catalog-item-pricing-dialog',
  templateUrl: './update-catalog-item-pricing-dialog.component.html',
  styleUrls: ['./update-catalog-item-pricing-dialog.component.scss'],
})
export class CatalogItemPricingDialogComponent implements OnInit {
  isProcessing: boolean = false;
  isLoading = false;
  selectedTab = 1;
  columns = [];
  pricingMatrix: any = {};
  isValidPartsList = false;
  isValidTiresList = false;
  isValidCannedList = false;
  partsList = [];
  tiresList = [];
  cannedList = [];
  FlatRateList = [];
  itemsCount = {
    parts: 0,
    tires: 0,
    canned: 0,
  };
  constructor(
    public dConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    public dataService: DataService,
    private formatService: FormatService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    const { pricingMatrix } = this.dConfig.data;
    this.pricingMatrix = pricingMatrix;
    this.setTableColumn();
  }

  closeDuplicateVehicleModal(data: any) {
    this.ref.close({ type: 'close', isSuccess: data });
  }

  revertAllSteppers() {
    this.isValidPartsList = false;
    this.isValidTiresList = false;
  }

  onBack() {
    // this.revertAllSteppers();
    const stage = this.selectedTab;
    if (stage === 2) {
      this.selectedTab = 1;
      this.isValidPartsList = true;
      this.revertAllSteppers();
    }
    if (stage === 3) {
      this.revertAllSteppers();
      this.selectedTab = 2;
      // this.isValidTiresList = true;
      this.isValidPartsList = true;
      this.isValidCannedList = false;
    }

    this.setTableColumn();
  }

  handleSubmit() {
    let stage = this.selectedTab;

    if (stage === 1) {
      this.selectedTab = 2;
      this.isValidPartsList = true;
    }
    if (stage === 2) {
      this.selectedTab = 3;
      this.isValidTiresList = true;
    }
    // if (stage === 3) {
    //   this.isValidCannedList = true;
    //   this.selectedTab = 4;
    // }
    this.setTableColumn();

    if (stage === 3) {
      this.isValidCannedList = true;
      const itemsCount = this.itemsCount.parts + this.itemsCount.tires + this.itemsCount.canned;
      const payload = {
        id: this.pricingMatrix._id,
        items: [...this.partsList, ...this.tiresList],
        cannedService: [...this.cannedList],
      }
      this.isProcessing = true;
      this.httpService.updateCatalogMatrixPricing(payload).then(response => {
        this.dataService.sendData({
          type: 'app-toaster',
          status: 'catalog-pricing success',
          message: {
            heading: 'Update!',
            body: `
          <div>
          <i class="fal fa-check-circle font-24"></i>
          </div>
          <div class="ml-30-mt-20">Pricing matrix for ${itemsCount} catalog items have been updated successfully</div>
          `,
          },
        });
        this.closeDuplicateVehicleModal(true);
        this.isProcessing = false;
      }).catch(err => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err)
      })

    }
  }

  setTableColumn() {
    if (this.selectedTab === 1) {
      this.columns = [
        { field: 'itemName', header: 'Item name', className: 'itemName' },
        { field: 'code', header: 'Part #', className: 'code' },
        { field: 'categoryName', header: 'Category', className: 'itemName' },
        { field: 'supplierNum', header: 'Supplier', className: 'code' },
        { field: 'cost', header: 'Cost', className: 'type' },
        { field: 'price', header: 'Current price', className: 'type' },
        { field: 'updatedPrice', header: 'Updated price', className: 'type' },
      ];
    }

    else if (this.selectedTab === 2) {
      this.columns = [
        { field: 'itemName', header: 'Item name', className: 'itemName' },
        { field: 'brand', header: 'Brand', className: 'itemName' },
        { field: 'model', header: 'Model', className: 'code' },
        { field: 'size', header: 'Size', className: 'code' },
        { field: 'code', header: 'Part #', className: 'code' },
        { field: 'supplierNum', header: 'Vendor', className: 'itemName' },
        { field: 'cost', header: 'Cost', className: 'type' },
        { field: 'price', header: 'Current price', className: 'type' },
        { field: 'updatedPrice', header: 'Updated price', className: 'type' },
      ];
    }
    else {
      this.columns = [
        { field: 'itemName', header: 'Name', className: 'itemName' },
        { field: 'categoryName', header: 'Category', className: 'itemName' },
        { field: 'itemCount', header: 'Items', className: 'type' },
        { field: 'cost', header: 'Cost', className: 'type' },
        { field: 'price', header: 'Current price', className: 'type' },
        { field: 'updatedPrice', header: 'Updated price', className: 'type' },
      ];
    }

  }

  handleSelectedItems(item) {

    const list = item.list.filter(item => !item.selectedItems);
    const unselectedItems = [];

    list.forEach(item => {
      if (unselectedItems.indexOf(item._id) === -1) {
        unselectedItems.push(item._id);
      }
    });

    if (item.type === 'part') {
      this.itemsCount.parts = item.totalRecords - unselectedItems.length;
      this.partsList = [];
      this.partsList.push(...unselectedItems);
    } else if (item.type === 'tire') {
      this.itemsCount.tires = item.totalRecords - unselectedItems.length;
      this.tiresList = [];
      this.tiresList.push(...unselectedItems);
    }
    else {
      this.itemsCount.canned = item.totalRecords - unselectedItems.length;
      this.cannedList = [];
      this.cannedList.push(...unselectedItems);
    }

    //For showing toaster count
    if (this.pricingMatrix?.updateSyncItems) {
      const list = item.list.filter(item => item.selectedItems && !item.isSelected);
      const selectedItems = [];

      list.forEach(item => {
        if (selectedItems.indexOf(item._id) === -1) {
          selectedItems.push(item._id);
        }
      });
      if (item.type === 'part') {
        this.itemsCount.parts = selectedItems.length;
      } else if (item.type === 'tire') {
        this.itemsCount.tires = selectedItems.length;
      }
      else {
        this.itemsCount.canned = selectedItems.length;
      }
    }
  }
}
